/** randomSort
 *  Array.sort function to totally random sort the array
 *
 *  @return {Number} A random number from -0.5 to +0.5
 */
function randomSort() {
  return 0.5 - Math.random();
}

export default randomSort;
